import moment from 'moment'

// lastUpdatedText renders a record's updatedAt for the "last updated …" footer.
// The Go services serialise an unset time.Time as 0001-01-01T00:00:00Z, which
// moment would happily render as "2026 years ago"; anything before 1970 (or
// unparseable) is treated as "not known" and shown as an em dash.
export const lastUpdatedText = (value) => {
  if (!value) return null
  const m = moment(value)
  if (!m.isValid() || m.year() < 1970) return '—'
  return m.fromNow()
}
